import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ProfileSidebarCard from "../components/OEMProfile/ProfileSidebarCard";
import ProfileTabs from "../components/OEMProfile/ProfileTabs";
import { fetchOEMProfile } from "../services/oemProfile/oemProfile";
import type { OEMProfile } from "../types/Profiles/oemProfile.types";
import { useTranslate } from "../hooks/LanguageProvider";

export default function OEMProfilePage() {
  const { id_user } = useParams();

  const [activeTab, setActiveTab] = useState("company");
  const [profile, setProfile] = useState<OEMProfile | null>(null);
  const [loading, setLoading] = useState(true);
  const { translate } = useTranslate();

  const loadProfile = async (showLoader = false) => {
    try {
      if (showLoader) {
        setLoading(true);
      }

      const rawUser = localStorage.getItem("user");
      const parsedUser = rawUser ? JSON.parse(rawUser) : null;

      const targetUserId = id_user || parsedUser?.id_user;

      if (!targetUserId) {
        console.error("id_user introuvable dans l'URL ou localStorage");
        setProfile(null);
        return;
      }

      const data = await fetchOEMProfile(targetUserId);
      setProfile(data);
    } catch (error) {
      console.error("Erreur chargement OEM profile:", error);
    } finally {
      if (showLoader) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    loadProfile(true);
  }, [id_user]);

  if (loading) {
    return (
      <div className="container-fluid py-4">
        <div className="card border-0 shadow-sm rounded-4">
          <div className="card-body text-center py-5">
            <div className="spinner-border text-primary" role="status" />
           <p className="mt-3 mb-0">{translate("loading_oem_profile")}</p>
          </div>
        </div>
      </div>
    );
  }

  if (!profile) {
    return (
      <div className="container-fluid py-4">
        <div className="alert alert-warning rounded-4 shadow-sm">
        {translate("no_oem_profile_found")}
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid py-4">
      <div className="row g-4">
        <div className="col-xl-4 col-lg-5">
          <ProfileSidebarCard
            profile={profile}
            onEdit={() => setActiveTab("company")}
            onProfileUpdated={() => loadProfile(false)}
          />
        </div>

        <div className="col-xl-8 col-lg-7">
          <ProfileTabs
            profile={profile}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            onProfileUpdated={() => loadProfile(false)}
          />
        </div>
      </div>
    </div>
  );
}